'use strict';

angular.module('TurneroApp').service('utilsService', [
	'seguridadService',
	'$window',
	'TurneroAppConstant',
	'$location',
	'miDoctaModoService',
    function (seguridadService, $window, TurneroAppConstant, $location, miDoctaModoService) {
		this.swalTitle = function (titulo, icon) {
			titulo = titulo == null || titulo == undefined ? '' : titulo;
			icon = icon == null || icon == undefined ? '' : icon;
			swal({
				title: titulo,
				type: icon,
				allowEscapeKey: false,
				allowOutsideClick: false
			});
			swal.showLoading();
		};

		this.swalNotification = function (titulo, texto, icon) {
			titulo = titulo == null || titulo == undefined ? '' : titulo;
			texto = texto == null || texto == undefined ? '' : texto;
			icon = icon == null || icon == undefined ? '' : icon;
			swal({
				title: titulo,
				html: texto,
				type: icon,
				allowEscapeKey: false,
				allowOutsideClick: false
			});
			swal.showLoading();
		};

        this.normalizarPatente = function (valor) {
			if (valor == null || valor === undefined || typeof valor !== 'string') return '';
			return valor
				.toUpperCase()
				.replace(/[^A-Z0-9]/g, ' ')
				.replace(/\s+/g, ' ')
				.trim();
		};

		this.errores = function (error, callback, continuarCallback, UrlGuiaTramites) {
			switch (error.status) {
                case 401: //Unauthorized
                case 403: //Forbidden
                    //Se desloguea la aplicación
                    seguridadService.logOut();
                    var currentPath = $location.path();
                    if (currentPath === '/llamador' || currentPath === '/recepcion') {
                        $window.location.reload();
                    } else if (miDoctaModoService.estaActivo()) {
                        // Modo iframe Mi Docta: no salir a CiDi, mostrar el cartel del iframe.
                        $window.location.href = miDoctaModoService.urlIframeError('sesion-expirada');
                    } else {
                        //Redirecciona a CiDI Login
                        $window.location.href = TurneroAppConstant.vedi.url + TurneroAppConstant.vedi.endpoint.login + TurneroAppConstant.vedi.veDiIdAplicacion;
                    }
                    break;
                case 409: //Conflict
                    //El Backend indica que la Cookie CiDi NO coincide con la de Turnero
                    seguridadService.logOut();
                    if (miDoctaModoService.estaActivo()) {
                        $window.location.href = miDoctaModoService.urlIframeError('sesion-expirada');
                    } else {
                        $window.location.reload();
                    }
                    break;
                case 404: //Not found
                    error.data = {
                        Message: "El método/proceso invocado no se ha encontrado."
                    };
                    break;
                case 408: //Timeout
                case 504: //Timeout
                    error.data = {
                        Message: "Se ha excedido el tiempo de espera."
                    };
                    break;
                case 406: //Not Acceptable
                    if (miDoctaModoService.estaActivo()) {
                        // Modo iframe Mi Docta: no salir a CiDi, quedarse en el flujo del iframe.
                        $window.location.href = miDoctaModoService.urlIframeError('sesion-expirada');
                    } else {
                        $window.location.href = TurneroAppConstant.vedi.ciDiUrlRelacion + TurneroAppConstant.vedi.ciDiIdAplicacion;
                    }
                    break;
			}

            var error_trigger = [];

            if (error.data) {
                if (error.data.ExceptionMessage) {
                    error_trigger = error.data.ExceptionMessage.split(":");
                }
                else if (error.data.Message) {
                    error_trigger = error.data.Message.split(":");
                }
            }
            else if (error.message) {
                error_trigger = error.message.split(":");
            }
            else if (error && typeof error === 'string') {
                error_trigger = error.split(":");
            }

			if (error_trigger.length > 1 && error_trigger[0] == "ERROR-ORA-20050") {
				if (error_trigger[1] != null && typeof error_trigger[1] === 'string') {
					swal({
						title: 'Ha ocurrido un error.',
						html: error_trigger[1].trim(),
						type: 'error',
						confirmButtonColor: '#3085d6',
						allowEscapeKey: false,
						allowOutsideClick: false,
						confirmButtonText: 'Aceptar'
					}).then(function () {
						if (callback) {
							callback();
						};
					})
				}
				else {
					var errorCode = (error_trigger[0] && typeof error_trigger[0] === 'string') ? error_trigger[0].trim() : '';
					swal({
						title: "Oops...",
						html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + errorCode + "</span>",
						type: "error",
						confirmButtonColor: '#3085d6',
						allowEscapeKey: false,
						allowOutsideClick: false,
						confirmButtonText: 'Aceptar'
					}).then(function () {
						if (callback) {
							callback();
						};
					})
				}
			} else {
                // FIX TMC-1412: Validar que error.statusText sea una cadena antes de hacer split
                // Agregar logs para debugging
                try {
                    var statusText = (error.statusText && typeof error.statusText === 'string') ? error.statusText : '';
                    var errorDataStr = null;
                    
                    if (error.data) {
                        if (error.data.ExceptionMessage && typeof error.data.ExceptionMessage === 'string') {
                            errorDataStr = error.data.ExceptionMessage;
                        } else if (error.data.Message && typeof error.data.Message === 'string') {
                            errorDataStr = error.data.Message;
                        } else if (typeof error.data === 'string') {
                            errorDataStr = error.data;
                        }
                    }
                    
                    var errorMessageStr = (error.message && typeof error.message === 'string') ? error.message : null;
                    var errorStr = (typeof error === 'string') ? error : null;
                    
                    var res = errorDataStr ? errorDataStr.split("-") : (errorMessageStr ? errorMessageStr.split("-") : (errorStr ? errorStr.split("-") : (statusText ? statusText.split("-") : null)));

                    if (res && res.length > 0 && res[0] && typeof res[0] === 'string')
                    {
                        switch (res[0].trim()) {
                        case "ADV":
                            if (res[1] != null && typeof res[1] === 'string') {
                                swal({
                                    title: 'Validar',
                                    html: res[1].trim(),
                                    type: 'warning',
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (callback) {
                                        callback();
                                    };
                                })
                            } else {
                                var advErrorCode = res[0] ? res[0].trim() : '';
                                swal({
                                    title: "Oops...",
                                    html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + advErrorCode + "</span>",
                                    type: "error",
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (callback) {
                                        callback();
                                    };
                                })
                            }
                            break;
                        case "PERS":
                            if (res[1] != null && typeof res[1] === 'string') {
                                var persHtml = (res[2] && typeof res[2] === 'string') ? res[2].trim() : '';
                                swal({
                                    title: res[1].trim(),
                                    html: persHtml,
                                    type: 'warning',
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (callback) {
                                        callback();
                                    };
                                })
                            } else {
                                var persErrorCode = res[0] ? res[0].trim() : '';
                                swal({
                                    title: "Oops...",
                                    html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + persErrorCode + "</span>",
                                    type: "error",
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (callback) {
                                        callback();
                                    };
                                })
                            }
                            break;
                        case "INFO":
                            if (res[1] != null && typeof res[1] === 'string') {
                                var infoHtml = (res[2] && typeof res[2] === 'string') ? res[2].trim() : '';
                                swal({
                                    title: res[1].trim(),
                                    html: infoHtml,
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {                                    
                                    if (continuarCallback) {
                                        continuarCallback();
                                    };
                                })
                            } else {
                                var infoErrorCode = res[0] ? res[0].trim() : '';
                                swal({
                                    title: "Oops...",
                                    html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + infoErrorCode + "</span>",
                                    type: "info",
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (continuarCallback) {
                                        continuarCallback();
                                    };
                                })
                            }
                            break;
                        case "RESTRICCION":
                            if (res[1] != null) {
                                swal({
                                    title: 'Atención',
                                    html: 'Estimado vecino/a, para acceder a este trámite lo invitamos a consultar la siguiente información <a target="_blank" href="' + UrlGuiaTramites + '">ingresando aquí</a>.',
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (callback) {
                                        callback();
                                    };
                                })
                            } else {
                                var restriccionErrorCode = res[0] ? res[0].trim() : '';
                                swal({
                                    title: "Oops...",
                                    html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + restriccionErrorCode + "</span>",
                                    type: "info",
                                    confirmButtonColor: '#004b81',
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Aceptar'
                                }).then(function () {
                                    if (continuarCallback) {
                                        continuarCallback();
                                    };
                                })
                            }
                            break;
                        default:
                            var defaultErrorCode = res[0] ? res[0].trim() : '';
                            swal({
                                title: "Oops...",
                                html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + defaultErrorCode + "</span>",
                                type: "error",
                                confirmButtonColor: '#004b81',
                                allowEscapeKey: false,
                                allowOutsideClick: false,
                                confirmButtonText: 'Aceptar'
                            }).then(function () {
                                if (callback) {
                                    callback();
                                };
                            })
                            break;
                    }
                } else {
                    // FIX TMC-1412: Si res es null, undefined, o no tiene elementos válidos, mostrar mensaje genérico
                    console.error('[utilsService.errores] Error sin estructura esperada:', {
                        error: error,
                        status: error.status,
                        statusText: error.statusText,
                        url: $location.path()
                    });
                    
                    swal({
                        title: "Oops...",
                        html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte.",
                        type: "error",
                        confirmButtonColor: '#004b81',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar'
                    }).then(function () {
                        if (callback) {
                            callback();
                        };
                    })
                }
                } catch (err) {
                    // FIX TMC-1412: Capturar cualquier error inesperado en el manejo de errores
                    console.error('[utilsService.errores] Error al procesar error:', err, {
                        originalError: error,
                        url: $location.path()
                    });
                    
                    swal({
                        title: "Oops...",
                        html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte.",
                        type: "error",
                        confirmButtonColor: '#004b81',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar'
                    }).then(function () {
                        if (callback) {
                            callback();
                        };
                    })
                }
			}
        },

		this.customError = function (error, tipo, titulo, callback) {
			try {
				// FIX TMC-1412: Validar tipos antes de hacer split y trim
				var errorDataStr = null;
				if (error.data) {
					if (error.data.ExceptionMessage && typeof error.data.ExceptionMessage === 'string') {
						errorDataStr = error.data.ExceptionMessage;
					} else if (error.data.Message && typeof error.data.Message === 'string') {
						errorDataStr = error.data.Message;
					}
				}
				var errorMessageStr = (error.message && typeof error.message === 'string') ? error.message : null;
				var errorStr = (typeof error === 'string') ? error : null;
				
				var error_trigger = errorDataStr ? errorDataStr.split(":") : (errorMessageStr ? errorMessageStr.split(":") : (errorStr ? errorStr.split(":") : []));
				
				if (error_trigger.length > 1 && error_trigger[0] == "ERROR-ORA-20050") {
					if (error_trigger[1] != null && typeof error_trigger[1] === 'string') {
						swal({
							title: 'Ha ocurrido un error.',
							html: error_trigger[1].trim(),
							type: 'error',
							confirmButtonColor: '#3085d6',
							allowEscapeKey: false,
							allowOutsideClick: false,
							confirmButtonText: 'Aceptar'
						}).then(function () {
							if (callback) {
								callback();
							};
						})
					}
					else {
						var customErrorCode = (error_trigger[0] && typeof error_trigger[0] === 'string') ? error_trigger[0].trim() : '';
						swal({
							title: "Oops...",
							html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + customErrorCode + "</span>",
							type: "error",
							confirmButtonColor: '#3085d6',
							allowEscapeKey: false,
							allowOutsideClick: false,
							confirmButtonText: 'Aceptar'
						}).then(function () {
							if (callback) {
								callback();
							};
						})
					}

				} else {
					var res = errorDataStr ? errorDataStr.split("-") : null;
					if (res && res.length > 0 && res[0] && typeof res[0] === 'string' && res[0].trim() == "ADV") {
						if (res[1] != null && typeof res[1] === 'string') {
							swal({
								title: titulo,
								html: res[1].trim(),
								type: 'warning',
								confirmButtonColor: '#3085d6',
								allowEscapeKey: false,
								allowOutsideClick: false,
								confirmButtonText: 'Aceptar'
							}).then(function () {
								if (callback) {
									callback();
								};
							})
						}
						else {
							var advCustomErrorCode = res[0] ? res[0].trim() : '';
							swal({
								title: titulo,
								html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + advCustomErrorCode + "</span>",
								type: 'error',
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'Aceptar',
								allowEscapeKey: false,
								allowOutsideClick: false
							});
						}
					}
					else {
						var defaultCustomErrorCode = (res && res[0] && typeof res[0] === 'string') ? res[0].trim() : '';
						sweetAlert("Oops...", "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte. </br><span style='display:none'> " + defaultCustomErrorCode + "</span>", "error");
					}
				}
			} catch (err) {
				// FIX TMC-1412: Capturar cualquier error inesperado en customError
				console.error('[utilsService.customError] Error al procesar error:', err, {
					originalError: error,
					url: $location.path()
				});
				
				swal({
					title: "Oops...",
					html: "Algo ocurrió  y no se pudo completar la acción.<br/> Intente nuevamente o comuníquese con soporte.",
					type: "error",
					confirmButtonColor: '#3085d6',
					allowEscapeKey: false,
					allowOutsideClick: false,
					confirmButtonText: 'Aceptar'
				}).then(function () {
					if (callback) {
						callback();
					};
				})
			}
        }

		this.matchRuleShort = function matchRuleShort(str, rule) {
			return new RegExp("^" + rule.split("*").join(".*") + "$").test(str);
		}

		this.requiredField = function (titulo, texto, icon) {
			swal({
				title: titulo,
				text: texto,
				type: icon,
				allowEscapeKey: false,
				allowOutsideClick: false,
				confirmButtonText: 'Aceptar'
			});
        }

		this.CUIL_Formateado = function (cuil) {

			return cuil ? cuil.substring(0, 2) + '-' + cuil.substring(2, 10) + '-' + cuil.substring(10, 11) : cuil;

		}

		this.tieneCuilParaMostrar = function (cuil) {
			var cuilLimpio = cuil ? cuil.toString().replace(/\D/g, '') : '';
			return cuilLimpio.length === 11;
		}

		this.removeAccents = function (value) {
			return value
				  .replace(/á/g, 'a')
				  .replace(/â/g, 'a')
				  .replace(/é/g, 'e')
				  .replace(/è/g, 'e')
				  .replace(/ê/g, 'e')
				  .replace(/í/g, 'i')
				  .replace(/ï/g, 'i')
				  .replace(/ì/g, 'i')
				  .replace(/ó/g, 'o')
				  .replace(/ô/g, 'o')
				  .replace(/ú/g, 'u')
				  .replace(/ü/g, 'u')
				  .replace(/ç/g, 'c')
				  .replace(/ß/g, 's');
        }

		this.getNumbersInString = function (string) {
			var tmp = string.split("");
			var map = tmp.map(function (current) {
				if (!isNaN(parseInt(current))) {
					return current;
				}
			});

			var numbers = map.filter(function (value) {
				return value != undefined;
			});

			return numbers.join("");
		}

        this.esAlfanumerico = function (text) {
            return /^[A-Za-zÁÉÍÓÚáéíóúÑñüÜ _1234567890]*$/.test(text);
        }
	}]);



// WEBPACK FOOTER //
// ./app/components/general/utilsService.js